import {gsap, ScrollTrigger} from "../LibrariesImport";
import LoadScript from "../utils/LoadScript";

export default class BlockVideosScroller {
    static init() {
        this.block = document.querySelector(".block-videos-scroller");

        if (!this.block) {
            return;
        }

        if (ScrollTrigger.isTouch !== 1) {
            this.buildTimelines();
        }

        this.playerInitInPlace();
    }

    static buildTimelines() {
        const wrapAll = this.block.querySelector('.wrap-all');
        const Arguments = this.block.querySelectorAll('.argument');
        const Title = this.block.querySelector('.arguments-title');
        const playerVideo = this.block.querySelector('.player-video');
        const PlayText = this.block.querySelector('.play-text');
        const PlayBtn = this.block.querySelector('.play-button');
        const youtube = this.block.querySelector('.youtube-movie');

        gsap.set(wrapAll, {width: () => this.wrapAllSize( true)});

        this.tl1 = gsap.timeline({
            scrollTrigger: {
                trigger: this.block,
                start: "top 80%",
                end: "center center",
                scrub: true,
                invalidateOnRefresh: true,
            }
        });

        this.tl1
            .to(wrapAll, {width: () => this.wrapAllSize(),  duration: 3 })
            .to(Title, {autoAlpha: 1, duration: 1});

        let screenCount = Arguments.length * 3;

        this.tl2 = gsap.timeline({
            scrollTrigger: {
                trigger: this.block,
                pin: true,
                scrub: true,
                invalidateOnRefresh: true,
                start: "center center",
                end: () => "+=" +this.block.offsetHeight * screenCount,
            },
        });

        Arguments.forEach((arg, index, array) => {
            const movie = arg.querySelector('.movie');
            const card = arg.querySelector('.card-arg');

            gsap.set(card, {autoAlpha: 0, transform: "translateY(100%)"});
            if (index !== 0) {
                gsap.set(movie, {autoAlpha: 0});
            }

            if (index === 0) { // First slide
                this.tl2
                    .addLabel("start")
                    .to(card, {autoAlpha: 1, duration: 1.5}, "start")
                    .to(card, {transform: "translateY(-50vh)", duration: 4}, "<")
                    .to(movie, {autoAlpha: 0, duration: 1}, "-=1")
                    .to(card, {autoAlpha: 0, duration: 1}, "<");

            } else {
                this.tl2
                    .to(movie, {autoAlpha: 1, duration: 1}, "-=1")
                    .to(card, {autoAlpha: 1, duration: 1.5}, "<")
                    .to(card, {transform: "translateY(-50vh)", duration: 4}, "<")
                    .to(movie, {autoAlpha: 0, duration: 1}, "-=1")
                    .to(card, {autoAlpha: 0, duration: 1}, "<");
            }
        });

        this.tl2
            .addLabel("player")
            .to(wrapAll, {width: () => this.wrapAllSize( true), duration: 3}, "player")
            .to(wrapAll, {height: () => this.wrapAllHeight(this.wrapAllSize( true)), duration: 3}, "player")
            .to(playerVideo, {autoAlpha: 1, duration: 1}, "player-=1")
            .to(Title, {autoAlpha: 0, duration: 1}, "player")
            .to(PlayText, {autoAlpha: 1, scale: 1, duration: 1}, "player")
            .to(PlayBtn, {
                opacity: 1,
                scale: 1,
                duration: 1,
                onComplete: () => {
                    wrapAll.classList.add('mousePlayBtnActive');
                },
                onReverseComplete: () => {
                    wrapAll.classList.remove('mousePlayBtnActive');
                }
            }, "<")
            .to(youtube, {autoAlpha: 1, duration: 1}, "<")
            .to({}, {duration: 3});

    }

    static wrapAllSize(min = false) {
        if (min) {
            const min = this.block.querySelector('.arguments').offsetWidth;
            return min;
        } else {
            const max = document.querySelector(".header-main").offsetWidth;
            return max;
        }
    }

    static wrapAllHeight(width) {
        return width * 0.5625;
    }

    static playerInitInPlace() {
        const playBtn = this.block.querySelector('.play-button');
        const playerYoutube = this.block.querySelector('.player-youtube');

        if (!playerYoutube) {
            return;
        }

        let videoID = playerYoutube.dataset.videoId;
        let player = playerYoutube.closest('.youtube-movie');
        this.youtubePlayer = null;

        playBtn.addEventListener('click', () => {
            playerYoutube.classList.add('playing');

            LoadScript.load('https://www.youtube.com/iframe_api', () => {
                if (!player.classList.contains('player-load')) {
                    setTimeout(()=>{
                        this.youtubePlayer = new YT.Player(videoID, {
                            height: '360',
                            width: '640',
                            videoId: videoID,
                            playerVars: {
                                'autoplay': 1,
                                'showinfo': 0,
                                'modestbranding': 1,
                                'rel': 0,
                                'enablejsapi': 1
                            }
                        });
                        player.classList.add('player-load');
                    }, 50);

                } else {
                    this.youtubePlayer.playVideo();
                }
            });
        });
    }

    static playerClose(youtubePlayer, modalPlayer) {
        youtubePlayer.pauseVideo();
        modalPlayer.classList.remove('playing');
    }
}
